export const EXCEL_FORMATS = [
  "text/csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/x-msexcel",
  "application/x-excel",
  "application/excel",
];
export const IMAGE_FORMATS = [
  "image/png",
  "image/apng",
  "image/avif",
  "image/bmp",
  "image/vnd.microsoft.icon",
  "image/svg+xml",
  "image/gif",
  "image/jpeg",
  "image/tiff",
  "image/webp",
];
export const AUDIO_FORMATS = [
  "audio/aac",
  "audio/midi",
  "audio/x-midi",
  "audio/mpeg",
  "audio/ogg",
  "audio/opus",
  "audio/wav",
  "audio/webm",
  "audio/3gpp",
  "audio/3gpp2",
];
export const VIDEO_FORMATS = [
  "video/x-msvideo",
  ".mp4",
  ".mpeg",
  ".ogg",
  ".mp2t",
  ".webm",
  ".3gpp",
  ".3gpp2",
  ".avi",
  ".mov",
  ".wmv",
];
export const DOCUMENT_FORMATS = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/pdf",
  "application/rtf",
];

export const ZIP_FORMATS = [
  "application/x-7z-compressed",
  ".zip",
  "application/vnd.rar",
  "application/x-tar",
  "application/gzip",
];

export const fileSizeUnit = [
  "Bytes",
  "KB",
  "MB",
  "GB",
  "TB",
  "PB",
  "EB",
  "ZB",
  "YB",
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export type ID = string | number;

export const SAMAB = "سماب";

/**
 * * `A` - Admin
 * * `S` - Staff
 */
export enum IStaffProfileEnum {
  Admin = "A",
  Staff = "S",
}

/**
 * * `M` - Male
 * * `F` - Female
 * * `O` - Other
 */
export enum IGenderEnum {
  male = "M",
  female = "F",
  others = "O",
}

/**
 * * `AS` - Assistant Professor
 * * `AO` - Associate Professor
 * * `FP` - Full Professor
 */
export enum IAcademicRankEnum {
  assistantProfessor = "AS",
  associateProfessor = "AO",
  fullProfessor = "FP",
}

/**
 * * `C` - Conference
 * * `J` - Journal
 */
export enum IPaperType {
  conference = "C",
  journal = "J",
}

/** source */
export enum ISourceEnum {
  G = "G",
  S = "S",
}

/**
 * * `T` - Translation
 * * `C` - Composition
 * * `A` - Authoring
 */
export enum IMemberBookType {
  translation = "T",
  composition = "C",
  authoring = "A",
}

/**
 * * `O` - Ongoing
 * * `D` - Done
 */
export enum IStatusEnum {
  ongoing = "O",
  done = "D",
}
